import { useEffect, useState } from 'react';
import { Textarea } from '../../../shared/components/Textarea';
import { TextInput } from '../../../shared/components/TextInput';
import { JobPosition, mensagemDeErro } from '../api';
import { useSalvarCargo } from '../hooks';
import { CadastroModal } from './CadastroModal';

interface Props {
  open: boolean;
  cargo: JobPosition | null;
  onClose: () => void;
  onSaved: (message: string) => void;
}

/** Máscara `0000-00` do código CBO. */
export function maskCbo(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 6);
  return digits.length > 4 ? `${digits.slice(0, 4)}-${digits.slice(4)}` : digits;
}

export function CargoFormModal({ open, cargo, onClose, onSaved }: Props) {
  const [code, setCode] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [cbo, setCbo] = useState('');
  const salvar = useSalvarCargo();

  useEffect(() => {
    if (!open) return;
    setCode(cargo?.code ?? '');
    setName(cargo?.name ?? '');
    setDescription(cargo?.description ?? '');
    setCbo(cargo?.cboCode ?? '');
    salvar.reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, cargo]);

  const cboInvalido = cbo !== '' && !/^\d{4}-\d{2}$/.test(cbo);

  async function handleSubmit() {
    try {
      await salvar.mutateAsync({
        id: cargo?.id,
        payload: {
          code: code.trim(),
          name: name.trim(),
          description: description.trim() || null,
          cboCode: cbo || null,
        },
      });
      onSaved(cargo ? 'Cargo atualizado.' : 'Cargo cadastrado.');
    } catch {
      // Erro exibido no próprio modal.
    }
  }

  return (
    <CadastroModal
      open={open}
      title={cargo ? 'Editar cargo' : 'Novo cargo'}
      submitLabel="Salvar"
      isSubmitting={salvar.isPending}
      submitError={salvar.isError ? mensagemDeErro(salvar.error, 'Não foi possível salvar o cargo.') : null}
      canSubmit={code.trim() !== '' && name.trim() !== '' && !cboInvalido}
      onClose={onClose}
      onSubmit={handleSubmit}
    >
      <TextInput label="Código" value={code} maxLength={40} onChange={(e) => setCode(e.target.value)} />
      <TextInput label="Nome" value={name} maxLength={160} onChange={(e) => setName(e.target.value)} />
      <TextInput
        label="Código CBO (opcional)"
        value={cbo}
        inputMode="numeric"
        error={cboInvalido ? 'Use o formato 0000-00.' : undefined}
        onChange={(e) => setCbo(maskCbo(e.target.value))}
      />
      <Textarea label="Descrição (opcional)" value={description} onChange={(e) => setDescription(e.target.value)} />
    </CadastroModal>
  );
}
